import React, { useEffect } from 'react';
import $ from 'jquery';
import '../styles/HeroSection.css';

const HeroSection: React.FC = () => {
  useEffect(() => {
    // Fade in animation on load
    $('.hero-content').animate({ opacity: 1 }, 1000);
  }, []);

  return (
    <section 
      className="hero-section"
      style={{ 
        backgroundImage: "url('/images/hero-background.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="hero-content">
        <blockquote className="hero-quote">
          „Egészséges bőr és ápolt körmök, kompromisszumok nélkül!”
        </blockquote>
        <p className="hero-author">Pelyák Adél</p>
      </div>
    </section>
  );
};

export default HeroSection; 